import PollSkeleton from '../../modules/poll/PollPage/skeleton';
import useNewPollPage from './vm';

const NewPollPage = () => {
  useNewPollPage();

  return <PollSkeleton />;
};

export default NewPollPage;
